'use client'

import { trackEvent } from '@/matomo/matomo.util'
import { AnchorButton, AnchorButtonProps } from '@dvinci/attract-studio-components'

export const ClientAnchorButton = (props: AnchorButtonProps) => {
  return <AnchorButton {...props} trackingScript={(targetUrl?: string) => trackEvent('Intro CTA custom onClick', targetUrl ?? 'no target')} />
}
